import { ReactNode, FC, memo } from "react";
import "./panel-action-area.scss";

type PanelActionAreaProps = {
  children: ReactNode;
  className?: string;
};

const PanelActionAreaComponent: FC<PanelActionAreaProps> = ({ className = "", children }) => {
  return <div className={`panel-action-area ${className}`}>{children}</div>;
};

export const PanelActionArea = memo(PanelActionAreaComponent);
